import { lazy, Suspense } from 'react';
// Remplacé à la construction : en production la condition est fausse, l'import
// dynamique et la page disparaissent du paquet.
const BancControleVisuel = import.meta.env.VITE_E2E === '1'
  ? lazy(() => import('./pages/e2e/ControleVisuelBanc'))
  : null;
const BancLivraison = import.meta.env.VITE_E2E === '1'
  ? lazy(() => import('./pages/e2e/LivraisonBanc'))
  : null;
const BancBonsEnfact = import.meta.env.VITE_E2E === '1'
  ? lazy(() => import('./pages/e2e/BonsEnfactBanc'))
  : null;
const BancCommandesIrsia = import.meta.env.VITE_E2E === '1'
  ? lazy(() => import('./pages/e2e/CommandesIrsiaBanc'))
  : null;
const BancControlePesee = import.meta.env.VITE_E2E === '1'
  ? lazy(() => import('./pages/e2e/ControlePeseeBanc'))
  : null;
const BancReleveVentes = import.meta.env.VITE_E2E === '1'
  ? lazy(() => import('./pages/e2e/ReleveVentesBanc'))
  : null;
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import LayoutV2 from './components/LayoutV2';
import Dashboard from './pages/Dashboard';
import Accueil from './pages/Accueil';
import OrdersSummary from './pages/OrdersSummary';

import DeliveriesList from './pages/DeliveriesList';
import DeliveryDetail from './pages/DeliveryDetail';
import CustomerDeliveries from './pages/CustomerDeliveries';
import DriversManagement from './pages/DriversManagement';
import SmsLivreurPage from './pages/SmsLivreurPage';
import CarnetRoutePage from './pages/CarnetRoutePage';
import RentabiliteEshopPage from './pages/RentabiliteEshopPage';
import RentabiliteMensuellePage from './pages/RentabiliteMensuellePage';
import DeliveryDashboard from './pages/DeliveryDashboard';
import POSWorkspace from './pages/pos/POSWorkspace';
import CustomerDisplayPage from './pages/pos/CustomerDisplayPage';
import RestockAlertsPage from './pages/pos/RestockAlertsPage';
import Welcome from './pages/Welcome';
import StocksWorkspace from './pages/StocksWorkspace';
import SaleLookup from './pages/SaleLookup';
import Products from './pages/Products';
import Categories from './pages/Categories';
import Checkout from './pages/Checkout';
import CustomerAccount from './pages/CustomerAccount';
import Settings from './pages/Settings';
import Onboarding from './pages/Onboarding';
import Catalog from './pages/Catalog';
import Sales from './pages/Sales';
import Inventory from './pages/Inventory';
import Orders from './pages/Orders';
import SalesHistory from './pages/SalesHistory';
import ClosingReportHistory from './pages/ClosingReportHistory';
import Stats from './pages/Stats';
import EnfactInvoicesPage from './pages/EnfactInvoicesPage';
import EnfactImportsPage from './pages/EnfactImportsPage';
import Customers from './pages/Customers';
import Team from './pages/Team';
import Profile from './pages/Profile';
import Login from './pages/Login';
// OrderPreparation est maintenant intégré dans POSWorkspace via OrderPreparationContent
// import OrderPreparation from './pages/OrderPreparation';
import BackroomManagement from './pages/BackroomManagement';
import ReceptionPage from './pages/pos/ReceptionPage';
import ReceptionBonsPage from './pages/reception/ReceptionBonsPage';
import ReceptionGuideePage from './pages/reception/ReceptionGuideePage';
import PreordersOverview from './pages/PreordersOverview';
import PreorderTypesPage from './pages/PreorderTypesPage';
import BakerClosures from './pages/BakerClosures';
import PackagingManagement from './pages/PackagingManagement';
import LabelTemplates from './pages/LabelTemplates';
import Analytics from './pages/Analytics';
import EcomReportPage from './pages/EcomReport';
import StockOuts from './pages/StockOuts';
import WorksheetsDashboard from './pages/worksheets/WorksheetsDashboard';
import ExecutorApp from './pages/worksheets/ExecutorApp';
import ProtectedRoute from './components/ProtectedRoute';
import RootRedirect from './components/RootRedirect';
import PromoDlcPage from './pages/PromoDlcPage';
import NouveautesPage from './pages/NouveautesPage';
import EtiquettesSemainePage from './pages/EtiquettesSemainePage';
import VendorProtectedRoute from './components/VendorProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import { CustomerProvider } from './contexts/CustomerContext';
import ToastProvider from './components/pos/ToastProvider';

// Nouvelles pages e-commerce
import EcommercePage from './pages/ecommerce/EcommercePage';
import ProduitPage from './pages/ecommerce/ProduitPage';
import CommandePubliquePage from './pages/ecommerce/CommandePubliquePage';
import ShopGate from './components/ecommerce/ShopGate';
import ShopFooterLayout from './components/ecommerce/layout/ShopFooterLayout';
import NotificationBadgeSync from './components/ecommerce/NotificationBadgeSync';
import PwaManifestSwitch from './components/PwaManifestSwitch';
import CustomerLoginPage from './pages/ecommerce/CustomerLoginPage';
import CheckoutPage from './pages/ecommerce/CheckoutPage';
import OrderConfirmationPage from './pages/ecommerce/OrderConfirmationPage';
import OrdersPage from './pages/ecommerce/OrdersPage';
import OrderDetailPage from './pages/ecommerce/OrderDetailPage';
import WalletPage from './pages/ecommerce/WalletPage';
import ProfilePage from './pages/ecommerce/ProfilePage';
import DeliveryTrackingPage from './pages/ecommerce/DeliveryTrackingPage';
import PhilosophyPage from './pages/ecommerce/PhilosophyPage';
import CGVPage from './pages/ecommerce/CGVPage';
import PrivacyPolicyPage from './pages/ecommerce/PrivacyPolicyPage';
import CookiePolicyPage from './pages/ecommerce/CookiePolicyPage';
import LegalNoticePage from './pages/ecommerce/LegalNoticePage';
import ResetPasswordPage from './pages/ecommerce/ResetPasswordPage';
import VerifyEmailPage from './pages/ecommerce/VerifyEmailPage';
import CartPage from './pages/ecommerce/CartPage';
import CookieBanner from './components/ecommerce/CookieBanner';

// Pages Publications - Admin
import PublicationsDashboard from './pages/merchant/publications/PublicationsDashboard';
import PublicationEditor from './pages/merchant/publications/PublicationEditor';
import PublicationAnalytics from './pages/merchant/publications/PublicationAnalytics';
import NewsletterSubscribersPage from './pages/merchant/publications/NewsletterSubscribersPage';
import GiftVouchersPage from './pages/merchant/GiftVouchersPage';

// Pages Publications - Client
import Feed from './pages/customer/feed/Feed';
import PublicationDetailPage from './pages/customer/feed/PublicationDetailPage';
import SubscriptionsPage from './pages/customer/feed/SubscriptionsPage';

// Pages Live Shopping - Vendeur
import LiveShoppingDashboard from './pages/live-shopping/LiveShoppingDashboard';
import LiveShoppingSession from './pages/live-shopping/LiveShoppingSession';

// Pages Live Shopping - Client (ancien système à /live-shopping)

// Pages Messaging
import Messaging from './pages/Messaging';

// Photo Retouching
import PhotoRetouching from './pages/PhotoRetouching';

// Production
import ProductionDashboard from './pages/production/ProductionDashboard';
import ZonesAndPlots from './pages/production/ZonesAndPlots';
import VarietiesAndSeeds from './pages/production/VarietiesAndSeeds';
import CropPlanning from './pages/production/CropPlanning';
import InputPurchases from './pages/production/InputPurchases';
import InterventionsJournal from './pages/production/InterventionsJournal';

// Storage (Stockage chaotique)
import StorageLocationsPage from './pages/storage/StorageLocationsPage';
import PutawayPage from './pages/storage/PutawayPage';
import PickingListPage from './pages/storage/PickingListPage';
import PickingGuidedPage from './pages/storage/PickingGuidedPage';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <CustomerProvider>
          <PwaManifestSwitch />
          <NotificationBadgeSync />
          <ToastProvider />
          <CookieBanner />
          <Routes>
            {/* Routes Publiques (sans authentification) */}
            <Route path="/login" element={<Login />} />
            <Route path="/onboarding" element={<Onboarding />} />

            {/* Route Welcome - Page d'accueil pour choisir POS ou Stocks (protégée) */}
            <Route path="/welcome" element={
              <VendorProtectedRoute>
                <Welcome />
              </VendorProtectedRoute>
            } />

            {/* Route POS Workspace - Unifie POS, Préparation et Live Shopping (protégée) */}
            <Route path="/pos" element={
              <VendorProtectedRoute>
                <POSWorkspace />
              </VendorProtectedRoute>
            } />

            {/* Route Stocks Workspace - Gestion des stocks (protégée) */}
            <Route path="/stocks" element={
              <VendorProtectedRoute>
                <StocksWorkspace />
              </VendorProtectedRoute>
            } />

            {/* Route Alertes de réapprovisionnement (protégée) */}
            <Route path="/pos/restock-alerts" element={
              <VendorProtectedRoute>
                <RestockAlertsPage />
              </VendorProtectedRoute>
            } />

            {/* Route Réception fournisseurs POS (protégée) */}
            <Route path="/pos/reception" element={
              <VendorProtectedRoute>
                <ReceptionPage />
              </VendorProtectedRoute>
            } />

            {/* Réception simplifiée (PWA-first) : liste des bons + parcours guidé ligne à ligne.
                La page complète /pos/reception reste la référence (import fichier, mise en rayon). */}
            <Route path="/reception" element={
              <VendorProtectedRoute>
                <ReceptionBonsPage />
              </VendorProtectedRoute>
            } />
            <Route path="/reception/:id" element={
              <VendorProtectedRoute>
                <ReceptionGuideePage />
              </VendorProtectedRoute>
            } />

            {/* Route Précommandes — vue d'ensemble accessible depuis le POS (vendeur) */}
            <Route path="/pos/preorders" element={
              <VendorProtectedRoute>
                <PreordersOverview />
              </VendorProtectedRoute>
            } />

            {/* Accueil tactile PWA-first (phase A, 05/08/2026) - Standalone, hors sidebar */}
            <Route path="/accueil" element={
              <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                <Accueil />
              </ProtectedRoute>
            } />

            {/* Storage (Stockage chaotique) - Standalone, hors du dashboard */}
            <Route path="/storage/locations" element={
              <VendorProtectedRoute>
                <StorageLocationsPage />
              </VendorProtectedRoute>
            } />
            <Route path="/storage/putaway" element={
              <VendorProtectedRoute>
                <PutawayPage />
              </VendorProtectedRoute>
            } />
            <Route path="/storage/picking" element={
              <VendorProtectedRoute>
                <PickingListPage />
              </VendorProtectedRoute>
            } />
            <Route path="/storage/picking/:id" element={
              <VendorProtectedRoute>
                <PickingGuidedPage />
              </VendorProtectedRoute>
            } />

            {/* Redirections vers le workspace avec onglet spécifique */}
            <Route path="/preparation" element={<Navigate to="/pos?tab=preparation" replace />} />

            {/* Route Executor iPad - Interface exécutant worksheets (protégée) */}
            <Route path="/executor" element={
              <VendorProtectedRoute>
                <ExecutorApp />
              </VendorProtectedRoute>
            } />

            {/* Écran client (2e moniteur HDMI face client) - Publique : aucune requête API,
                n'affiche que ce que la fenêtre POS locale diffuse via BroadcastChannel */}
            <Route path="/pos/affichage-client" element={<CustomerDisplayPage />} />

            {/* Racine du site : client → boutique, équipe connectée → dashboard */}
            <Route path="/" element={<RootRedirect />} />

            {/* Route de consultation de vente via QR code - Publique */}
            <Route path="/sales/:saleId" element={<SaleLookup />} />
            {/* Banc d'essai du contrôle visuel : construction de TEST seulement (VITE_E2E=1). */}
            {BancControleVisuel && (
              <Route path="/e2e/controle-visuel" element={<Suspense fallback={null}><BancControleVisuel /></Suspense>} />
            )}
            {BancLivraison && (
              <Route path="/e2e/livraison" element={<Suspense fallback={null}><BancLivraison /></Suspense>} />
            )}
            {BancBonsEnfact && (
              <Route path="/e2e/bons-enfact" element={<Suspense fallback={null}><BancBonsEnfact /></Suspense>} />
            )}
            {BancCommandesIrsia && (
              <Route path="/e2e/commandes-irsia" element={<Suspense fallback={null}><BancCommandesIrsia /></Suspense>} />
            )}
            {BancControlePesee && (
              <Route path="/e2e/controle-pesee" element={<Suspense fallback={null}><BancControlePesee /></Suspense>} />
            )}
            {BancReleveVentes && (
              <Route path="/e2e/releve-ventes" element={<Suspense fallback={null}><BancReleveVentes /></Suspense>} />
            )}

            {/* Routes E-Commerce Client (publiques) — protégées par le portail
                d'accès pré-lancement (ShopGate) tant que ESHOP_PRELAUNCH_CODE est défini */}
            <Route element={<ShopGate />}>
            {/* Le catalogue porte son pied de page dans sa propre zone de
                défilement (sa mise en page fait exactement la hauteur d'écran). */}
            <Route path="/shop" element={<EcommercePage />} />
            {/* Liens partagés ouverts par l'application elle-même (ancienne copie
                locale du site encore active sur un téléphone) : ne jamais rester
                sur une page blanche, renvoyer vers la fiche ou l'actualité. */}
            <Route path="/p/:id" element={<RedirectionLienPartage type="produit" />} />
            <Route path="/a/:id" element={<RedirectionLienPartage type="actualite" />} />

            {/* Toutes les autres pages du site reçoivent le pied de page légal
                (coordonnées + TVA) par cette enveloppe — demande d'un contrôleur
                de la Région wallonne. */}
            <Route element={<ShopFooterLayout />}>
            <Route path="/shop/cart" element={<CartPage />} />
            <Route path="/shop/login" element={<CustomerLoginPage />} />
            <Route path="/shop/reset-password" element={<ResetPasswordPage />} />
            <Route path="/shop/verify-email" element={<VerifyEmailPage />} />
            <Route path="/shop/checkout" element={<CheckoutPage />} />
            {/* Route de confirmation AVANT orders/:id pour éviter les conflits */}
            <Route path="/shop/order-confirmation/:orderId" element={<OrderConfirmationPage />} />
            <Route path="/shop/orders" element={<OrdersPage />} />
            <Route path="/shop/orders/:orderId" element={<OrderDetailPage />} />
            {/* Route de suivi de livraison en temps réel */}
            <Route path="/shop/track/:orderId" element={<DeliveryTrackingPage />} />
            <Route path="/shop/wallet" element={<WalletPage />} />
            <Route path="/shop/profile" element={<ProfilePage />} />
            <Route path="/shop/philosophy" element={<PhilosophyPage />} />
            <Route path="/shop/cgv" element={<CGVPage />} />
            <Route path="/shop/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/shop/cookies" element={<CookiePolicyPage />} />
            <Route path="/shop/mentions-legales" element={<LegalNoticePage />} />

            {/* Routes Publications Client (E-commerce) */}
            <Route path="/shop/feed" element={<Feed />} />
            <Route path="/shop/publications/:id" element={<PublicationDetailPage />} />
            <Route path="/shop/subscriptions" element={<SubscriptionsPage />} />
            {/* Page propre d'un produit, indexable (18/10/2026) */}
            <Route path="/shop/p/:segment" element={<ProduitPage />} />
            {/* Commande ouverte par le QR du ticket client (20/10/2026) */}
            <Route path="/shop/c/:jeton" element={<CommandePubliquePage />} />
            </Route>{/* fin ShopFooterLayout */}
            </Route>{/* fin ShopGate */}

            {/* Route Live Shopping Client - voir routes protégées /live-shopping */}

            {/* Live Shopping Session - Sans layout (ouvre dans popup depuis workspace, protégée) */}
            <Route
              path="/live-shopping/session/:sessionId/:vendorId?"
              element={
                <VendorProtectedRoute>
                  <LiveShoppingSession />
                </VendorProtectedRoute>
              }
            />

            {/* Routes E-Commerce Client (anciennes - à migrer) */}
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/account" element={<CustomerAccount />} />

          {/* Routes Protégées (requiert authentification Admin/Manager) */}
          <Route path="/" element={<LayoutV2 />}>
            {/* Pas de route index : la racine `/` est servie par RootRedirect (ci-dessus) */}

            {/* Dashboard - Admin & Manager */}
            <Route
              path="dashboard"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <Dashboard />
                </ProtectedRoute>
              }
            />

            {/* Publications Routes - Admin & Manager */}
            <Route
              path="publications"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <PublicationsDashboard />
                </ProtectedRoute>
              }
            />
            {/* Déclarée AVANT publications/:id, sinon « abonnes » serait pris pour un identifiant */}
            <Route
              path="publications/abonnes"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <NewsletterSubscribersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="bons-cadeaux"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <GiftVouchersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="publications/create"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <PublicationEditor />
                </ProtectedRoute>
              }
            />
            <Route
              path="publications/:id"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <PublicationEditor />
                </ProtectedRoute>
              }
            />
            <Route
              path="publications/:id/edit"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <PublicationEditor />
                </ProtectedRoute>
              }
            />
            <Route
              path="publications/:id/analytics"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <PublicationAnalytics />
                </ProtectedRoute>
              }
            />

            {/* Catalog Routes - Admin & Manager */}
            <Route
              path="catalog"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <Catalog />
                </ProtectedRoute>
              }
            />
            <Route
              path="promos-dlc"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <PromoDlcPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="nouveautes"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <NouveautesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="etiquettes-semaine"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <EtiquettesSemainePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="products"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <Products />
                </ProtectedRoute>
              }
            />
            <Route
              path="categories"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <Categories />
                </ProtectedRoute>
              }
            />
            <Route
              path="inventory"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <Inventory />
                </ProtectedRoute>
              }
            />
            {/* ai-parsing supprimé — intégré dans /pos/reception onglet Import */}
            <Route
              path="photo-retouching"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <PhotoRetouching />
                </ProtectedRoute>
              }
            />

            {/* Sales Routes - Admin & Manager */}
            <Route
              path="sales"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <Sales />
                </ProtectedRoute>
              }
            />
            <Route
              path="orders-summary"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <OrdersSummary />
                </ProtectedRoute>
              }
            />
            <Route
              path="orders"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <Orders />
                </ProtectedRoute>
              }
            />
            <Route
              path="sales-history"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <SalesHistory />
                </ProtectedRoute>
              }
            />
            <Route
              path="closing-reports"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <ClosingReportHistory />
                </ProtectedRoute>
              }
            />
            <Route
              path="stock-outs"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <StockOuts />
                </ProtectedRoute>
              }
            />
            <Route
              path="stats"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <Stats />
                </ProtectedRoute>
              }
            />
            <Route
              path="invoices"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <EnfactInvoicesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="imports"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <EnfactImportsPage />
                </ProtectedRoute>
              }
            />

            {/* Deliveries Routes - Admin & Manager */}
            <Route
              path="deliveries"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <DeliveriesList />
                </ProtectedRoute>
              }
            />
            <Route
              path="deliveries/:id"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <DeliveryDetail />
                </ProtectedRoute>
              }
            />

            {/* Preorders Routes - Admin & Manager */}
            <Route
              path="preorders-overview"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <PreordersOverview />
                </ProtectedRoute>
              }
            />
            {/* « Précommandes Pains » a été fusionnée dans la vue d'ensemble
                (18/08/2026) : elle en dupliquait la liste sans savoir chercher,
                modifier ni annuler, et se limitait à quatre dates. Ses trois
                impressions y ont été rapatriées, par journée. La route reste
                pour les favoris déjà posés. */}
            <Route path="preorders" element={<Navigate to="/preorders-overview" replace />} />
            <Route
              path="baker-closures"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <BakerClosures />
                </ProtectedRoute>
              }
            />
            <Route
              path="preorder-types"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <PreorderTypesPage />
                </ProtectedRoute>
              }
            />

            {/* BackroomStock supprimé — remplacé par /pos/reception */}

            {/* Backroom Management (avec gestion des lots) - Admin & Manager */}
            <Route
              path="backroom-management"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <BackroomManagement />
                </ProtectedRoute>
              }
            />

            {/* Customer Deliveries Routes - Admin & Manager */}
            <Route
              path="customer-deliveries"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <CustomerDeliveries />
                </ProtectedRoute>
              }
            />

            {/* Carnet de route de la camionnette (26/10/2026) */}
            <Route
              path="customer-deliveries/carnet"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <CarnetRoutePage />
                </ProtectedRoute>
              }
            />

            {/* SMS du livreur — textes réglables (15/10/2026) */}
            <Route
              path="customer-deliveries/sms"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <SmsLivreurPage />
                </ProtectedRoute>
              }
            />

            {/* Delivery Dashboard - Real-time tracking - Admin & Manager */}
            <Route
              path="delivery-dashboard"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <DeliveryDashboard />
                </ProtectedRoute>
              }
            />

            {/* Drivers Management - Admin & Manager */}
            <Route
              path="drivers"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <DriversManagement />
                </ProtectedRoute>
              }
            />


            {/* Packaging Management (Consignes/Vidanges) - Admin & Manager */}
            <Route
              path="packaging"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <PackagingManagement />
                </ProtectedRoute>
              }
            />

            {/* Label Templates (Étiquettes Zebra) - Admin & Manager */}
            <Route
              path="label-templates"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <LabelTemplates />
                </ProtectedRoute>
              }
            />

            {/* Analytics - Admin & Manager */}
            <Route
              path="analytics"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <Analytics />
                </ProtectedRoute>
              }
            />

            {/* Relevé mensuel pour la mesure de rentabilité (27/10/2026) */}
            <Route
              path="releve-mensuel"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <RentabiliteMensuellePage />
                </ProtectedRoute>
              }
            />

            {/* Rentabilité de la boutique en ligne (26/10/2026) */}
            <Route
              path="rentabilite-eshop"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <RentabiliteEshopPage />
                </ProtectedRoute>
              }
            />

            {/* Rapport E-commerce - Admin & Manager */}
            <Route
              path="ecom-reports"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <EcomReportPage />
                </ProtectedRoute>
              }
            />

            {/* Production Routes - Admin & Manager */}
            <Route
              path="production"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <ProductionDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="production/zones"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <ZonesAndPlots />
                </ProtectedRoute>
              }
            />
            <Route
              path="production/varieties"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <VarietiesAndSeeds />
                </ProtectedRoute>
              }
            />
            <Route
              path="production/planning"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <CropPlanning />
                </ProtectedRoute>
              }
            />
            <Route
              path="production/inputs"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <InputPurchases />
                </ProtectedRoute>
              }
            />
            <Route
              path="production/journal"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <InterventionsJournal />
                </ProtectedRoute>
              }
            />

            {/* Storage routes moved outside LayoutV2 — see standalone routes below */}

            {/* Worksheets - Admin & Manager */}
            <Route
              path="worksheets"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <WorksheetsDashboard />
                </ProtectedRoute>
              }
            />

            {/* Live Shopping Dashboard - Admin & Manager */}
            <Route
              path="live-shopping"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <LiveShoppingDashboard />
                </ProtectedRoute>
              }
            />
            {/* Note: live-shopping/session est défini hors du layout (popup) */}

            {/* Messaging - Admin & Manager */}
            <Route
              path="messaging"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <Messaging />
                </ProtectedRoute>
              }
            />

            {/* Customers - Admin & Manager */}
            <Route
              path="customers"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <Customers />
                </ProtectedRoute>
              }
            />

            {/* Settings - Admin uniquement */}
            <Route
              path="settings"
              element={
                <ProtectedRoute roles={['ADMIN']}>
                  <Settings />
                </ProtectedRoute>
              }
            />
            <Route
              path="settings/:section"
              element={
                <ProtectedRoute roles={['ADMIN']}>
                  <Settings />
                </ProtectedRoute>
              }
            />

            {/* Team standalone (kept for backward compatibility) */}
            <Route
              path="team"
              element={
                <ProtectedRoute roles={['ADMIN']}>
                  <Team />
                </ProtectedRoute>
              }
            />

            {/* Profile - Tous les utilisateurs authentifiés */}
            <Route
              path="profile"
              element={
                <ProtectedRoute roles={['ADMIN', 'MANAGER']}>
                  <Profile />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
        </CustomerProvider>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;

/** `/p/<id>` → fiche produit, `/a/<id>` → actualité (voir les routes ci-dessus). */
function RedirectionLienPartage({ type }: { type: 'produit' | 'actualite' }) {
  const { id } = useParams();
  if (!id) return <Navigate to="/shop" replace />;
  return <Navigate to={type === 'produit' ? `/shop?produit=${encodeURIComponent(id)}` : `/shop/publications/${encodeURIComponent(id)}`} replace />;
}
